import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { SKELETON_CLASSNAME, SKELETON_DUMMYTEXT } from '../../base/constants';
import { EDomain } from '../../base/types';
import ExercisesContainer from '../../components/exercises/ExercisesContainer';
import DomainHighscores from './DomainHighscores';
import './PerformanceView.scss';
import './TabViews.scss';

export interface IPerformanceContainerProps {
  domain: EDomain;
  userId?: number;
}

export const PerformanceContainer: React.FC<IPerformanceContainerProps> = ({ domain, userId }) => {
  const { t, language } = useTranslation();

  const loading = typeof domain === 'undefined' || !language;
  const skeletonClass = loading ? SKELETON_CLASSNAME : undefined;
  let domainIcon;
  let domainTitle = SKELETON_DUMMYTEXT;
  if (!loading) {
    domainIcon = `feature/icons/${EDomain[domain]}.png`;
    domainTitle = t(`common:Domain.Title.${domain}`);
  }
  return (
    <ExercisesContainer icon={domainIcon} title={domainTitle} skeletonClass={skeletonClass}>
      <DomainHighscores domain={domain} numberOfColumns={2} userId={userId} />
    </ExercisesContainer>
  );
};

export default PerformanceContainer;
